var exports = {
  "i": "xaee3c4fa--dd52a1--wrapper",
};

module.exports = exports;
